// Real SWMM matches element ids CASE-INSENSITIVELY end to end. This port's
// own plain `Map`s only match identical casing — usually true in practice,
// but not guaranteed. A `[COORDINATES]` row whose name differs in case from
// its `[JUNCTIONS]`/`[CONDUITS]` row is the sharpest symptom: the node/link
// reads fine, but its position is silently unresolvable.
//
// Applied only at the highest-traffic lookup paths (property-panel row
// resolution, `[COORDINATES]` lookups, rename collision checks) — every
// OTHER plain `Map`/`===` name comparison in the model/UI layer (link
// `fromNode`/`toNode` lookups, auto-name collision checks) is still
// case-sensitive. Not a project-wide fix.

/** `O(1)` on the common (already-matching) path; `O(map.size)` only on a miss. */
export function getCaseInsensitive<V>(map: ReadonlyMap<string, V>, name: string): V | undefined {
  const direct = map.get(name);
  if (direct !== undefined) return direct;
  const upper = name.toUpperCase();
  for (const [key, value] of map) {
    if (key.toUpperCase() === upper) return value;
  }
  return undefined;
}

/** Case-insensitive equality, not a locale-aware compare. */
export function sameId(a: string, b: string): boolean {
  return a.toUpperCase() === b.toUpperCase();
}
